export default __webpack_public_path__ + "static/media/bet-and-earn-banner-ms.e3bb94a7.webp";